import React, { useState } from "react";

import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";

import _ from "lodash";

import { useQuery } from "@apollo/react-hooks";
import { loader } from "graphql.macro";

const PROJECTS = loader("./graphql/ProjectList.gql");

export default (props) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const { loading } = useQuery(PROJECTS, {
    skip: !open,
    variables: {
      order_by: [{ project_name: "asc" }],
    },
    onCompleted(data) {
      setOptions(_.get(data, "projects") || []);
    },
  });

  return (
    <Autocomplete
      {...props}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={options.sort(
        (a, b) =>
          -b.project_name[0]
            .toUpperCase()
            .localeCompare(a.project_name[0].toUpperCase())
      )}
      groupBy={(option) => option.project_name[0].toUpperCase()}
      getOptionSelected={(option, value) =>
        option.project_id === value.project_id
      }
      getOptionLabel={(option) => option.project_name}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="โปรเจคท์"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
